import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const PartyMainSearchTable = (props) => {
    return (
        <>
            {/* 1. Item Search  */}
            <div className="item-search">
                <div className="item-grp flex gap-2.5 mb-2.5 w-[50%]">
                    <div className="search-grp w-[60%]">
                        <label>Invoice No.</label>
                        <input
                            type="text"
                            id="invoiceNo"
                            name="invoiceNo"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.filterDetails.invoiceNo}
                            onChange={(event) =>
                                props.handleChange(event, "invoiceNo", "filterDetails")
                            }
                        />
                    </div>

                    <div className="search-grp w-[40%]">
                        <label>Arranged By</label>
                        <select
                            name="arrangedBy"
                            className="w-full"
                            value={props.filterDetails.arrangedBy}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "arrangedBy",
                                    "filterDetails"
                                )
                            }
                        >
                            <option>Select</option>
                            {props.arrangedByList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.arrangedBy}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
                <button className="add-btn" onClick={props.getGSTInvoiceFinishGoodsInvoiceNo}>
                    Generate Invoice
                </button>
            </div>

            {/* 2. Item tabel  */}
            <div className="itemList-table">
                <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                    <table className="itemList">
                        <thead>
                            <tr>
                                <td className="w-[10%]">Inv. No</td>
                                <td className="w-[10%]">Inv.Date</td>
                                <td className="w-[20%]">Party Name</td>
                                <td className="w-[15%]">Net Amount</td>
                                <td className="w-[15%]">Transport Name</td>
                                <td className="w-[10%]">L.R. No</td>
                                <td className="w-[10%]">L.R. Date</td>
                                <td className="w-[10%] !text-center">Action</td>
                            </tr>
                        </thead>

                        {props.gstInvoiceFinishGoodsList && props.gstInvoiceFinishGoodsList.length > 0
                            ? props.gstInvoiceFinishGoodsList.map((item, key) => (
                                <tbody key={key}>
                                    <tr>
                                        <td>{item.invoiceNo}</td>
                                        <td>{moment(item.invoiceDate).format('DD MMM yyyy')}</td>
                                        <td>{item.partyId.partyName}</td>
                                        <td>{(item.grandTotal && Number(item.grandTotal) > 0) ? Number(item.grandTotal).toFixed(2) : 0}</td>
                                        <td>{item?.transportId?.transportName}</td>
                                        <td>{item.lRNo}</td>
                                        <td>{item.lRDate ? moment(item.lRDate).format('DD MMM yyyy') : ''}</td>

                                        <td className='!text-center'>
                                            <button
                                                className="search-btn"
                                                onClick={() => props.getGSTInvoiceFinishGoodsById(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faPen} />
                                            </button>
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteInvoiceById(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            ))
                            : props.gstInvoiceFinishGoodsList
                                && props.gstInvoiceFinishGoodsList.length === 0
                                && props.tableStatus !== "" ? (
                                <tr>
                                    <td colSpan={8} style={{ textAlign: "center", fontSize: "16px" }}>
                                        {props.tableStatus}
                                    </td>
                                </tr>
                            ) : props.gstInvoiceFinishGoodsList
                                && props.gstInvoiceFinishGoodsList.length === 0
                                && props.tableStatus === "" ? null : ""}

                    </table>
                </div>
            </div>
        </>
    );
};

export default PartyMainSearchTable;